import { createReducer, createActions } from 'reduxsauce';
import update from 'immutability-helper';
import type { ApiValidationError } from 'contracts/Common';

const { Types, Creators } = createActions(
  {
    request: ['postData', 'onSuccess', 'onFailure'],
    success: [],
    failure: ['errorMessage', 'validationErrors'],
    softReset: [],
    reset: [],
  },
  { prefix: 'CREATE_PHYSICAL_DOCK_' }
);

export interface CreatePhysicalDockState {
  loading: boolean;
  errorMessage: string | null;
  validationErrors: ApiValidationError[];
}

export interface CreatePhysicalDockRequestAction {
  postData: Record<string, any>;
  onSuccess?: () => boolean | void;
  onFailure?: () => boolean | void;
}

interface FailureAction {
  errorMessage: string;
  validationErrors?: ApiValidationError[];
}

const INITIAL_STATE: CreatePhysicalDockState = {
  loading: false,
  errorMessage: null,
  validationErrors: [],
};

const request = (state: CreatePhysicalDockState) =>
  update(state, {
    loading: { $set: true },
    errorMessage: { $set: null },
    validationErrors: { $set: [] },
  });

const success = (state: CreatePhysicalDockState) =>
  update(state, { loading: { $set: false } });

const failure = (state: CreatePhysicalDockState, action: FailureAction) =>
  update(state, {
    loading: { $set: false },
    errorMessage: { $set: action.errorMessage },
    validationErrors: { $set: action.validationErrors || [] },
  });

const softReset = (state: CreatePhysicalDockState) =>
  update(state, { loading: { $set: false } });

const reset = () => INITIAL_STATE;

export const createPhysicalDock = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: request,
  [Types.SUCCESS]: success,
  [Types.FAILURE]: failure,
  [Types.SOFT_RESET]: softReset,
  [Types.RESET]: reset,
});

export const CreatePhysicalDockTypes = Types;
export const CreatePhysicalDockActions = Creators;
